<template>
  <div class="module-content">
    <div class="edit-editor-content">
      <el-form ref="editModule" :model="formData" :rules="rules">
        <div v-for="(item, index) in formList" class="position-r"
          :class="{'inline': item.field === 'university' || item.field === 'major' || item.field === 'city' || item.field === 'uni_school' || item.field === 'dept' || item.labelCn === '担任角色' || item.field === 'degree' || item.field === 'show_tags',
                    'margin': item.field === 'university' || item.field === 'uni_school' || item.field === 'dept' || item.field === 'major' || item.labelCn === '担任角色'}"
          :key="index">
          <div v-if="item.type === 'datetime'">
            <div class="edit-module-item-name margin-top-24">{{item.labelCn}}</div>
            <div class="edit-editor-menu">
              <div class="edit-editor-item">
                <el-form-item>
                  <el-input v-if="moduleType === 'honor'" v-model="formData.present"
                      placeholder="请填写"
                      @change="val => change('formData', 'start_at', val)"/>
                  <el-date-picker v-else v-model="formData.start_at"
                      type="month" placeholder="开始时间" value-format="yyyy-MM"
                      @change="val => change('formData', 'start_at', val)" :default-value="defaultStartTime" :picker-options="startTimePickerOptions" />
                </el-form-item>
              </div>
              <div class="edit-editor-item" v-if="moduleType !== 'honor'">
                <div class="edit-item-now" v-if="formData.present && !formData.end_at">{{formData.present}}</div>
                <el-form-item prop="end_at">
                  <el-date-picker
                      ref="endat"
                      v-model="formData.end_at"
                      type="month"
                      placeholder="结束时间"
                      value-format="yyyy-MM"
                      :picker-options="pickerOptions"
                      :editable="false"
                      :validate-event="true"
                      :default-value="defaultEndTime"
                      @input="val => change('formData', 'end_at', val)"/>
                </el-form-item>
              </div>
            </div>
          </div>
          <div :key="index" v-else>
            <div class="edit-module-item-name margin-top-24">{{ item.labelCn }}</div>
						<!-- 城市 -->
            <el-form-item v-if="item.field === 'city'">
              <select-city :data="formData" @select="selectCityValue"/>
            </el-form-item>
						<!-- 学校 -->
            <el-form-item v-else-if="item.field === 'university'">
              <select-university v-if="cvDetail.basic_info.lang==='cn'" :data="formData" @select="selectUniversityValue" @universityBlurFunc="universityBlurFunc"/>
							<el-input v-else placeholder="请输入" class="slect-input-auto-main" v-model="formData.university"/>
            </el-form-item>
            <!-- 学校 Tag -->
            <el-form-item v-else-if="item.field === 'show_tags' && formData.show_tags">
              <el-checkbox-group v-model="formData.show_tags">
                <el-checkbox v-for="itemD in tags[cvLang]" :label="itemD.label" :value="itemD.value" :key="itemD.value"></el-checkbox>
              </el-checkbox-group>
            </el-form-item>
						<!-- 专业 -->
            <el-form-item v-else-if="item.field === 'major'">
              <select-major v-if="cvDetail.basic_info.lang==='cn'" :data="formData" @select="selectMajorValue"/>
							<el-input v-else placeholder="请输入" class="slect-input-auto-main" v-model="formData.major" @input="formData.major_id = ''" />
            </el-form-item>
            <div class="edit-editor-menu" v-else-if="item.field === 'degree'">
              <!-- 学历 -->
              <div class="edit-editor-item">
                <el-select clearable v-model="formData.degree" value-key="id" placeholder="请选择" @change="selectDegreeValue" v-if="cvDetail.basic_info.lang==='cn'">
                  <el-option v-for="(option, index) in degreeOption" :key="index" :label="option.cn" :value="option"/>
                </el-select>
                <el-select clearable v-model="formData.degree" placeholder="请选择" value-key="id" @change="selectDegreeValue" v-else>
                  <el-option v-for="(option, index) in degreeOption" :key="index" :label="option.en" :value="option"/>
                </el-select>
              </div>
              <!-- 学制 -->
              <div class="edit-editor-item" v-if="cvDetail.basic_info.lang==='cn'">
                <el-form-item class="position-r">
                  <el-select clearable v-model="formData.edu_type" placeholder="请选择" @change="$forceUpdate()">
                    <el-option v-for="option in ['全日制', '非全日制', '交换/交流']" :key="option" :label="option" :value="option"/>
                  </el-select>
                </el-form-item>
              </div>
            </div>
            <!-- 学院 -->
            <el-form-item v-else-if="item.field === 'uni_school'">
              <select-unischool :data="formData"/>
            </el-form-item>
            <!-- 公司名称 -->
            <el-form-item v-else-if="item.field === 'company'">
              <select-company :data="formData"/>
            </el-form-item>
            <!-- 职位名称 -->
            <el-form-item v-else-if="item.field === 'title'" prop="title" :class="[isShowAutoWriteError ? 'is-error' : '']">
              <select-position :data="formData"/>
              <div class="error-box" v-if="isShowAutoWriteError">
                <i class="iconfont iconcuowu"/><span>填写职位名称后开启</span>
              </div>
            </el-form-item>
            <!-- 其他所有 -->
            <el-form-item v-else :prop="item.field">
              <el-input v-model="formData[item.field]" :placeholder="item.placeholderCn" clearable></el-input>
            </el-form-item>
          </div>
          <suggest-card
              v-if="suggestInfo.suggest && suggestInfo.field && (suggestInfo.field === item.field  || suggestInfo.field === item.type)"
              @handleClose="handleClose"></suggest-card>
        </div>
      </el-form>
      <!-- 机构号入口 -->
      <!-- <div class="groups-entry-box" v-if="groupsEntryVisible" @click="showGroupsDialogFunc()">
        <i class="iconfont iconcv-title-icon-edus"></i>
        <p>「<span>{{ formData.university }}</span>」校友专属会员免费领取</p>
        <i class="iconfont iconjinru"></i>
      </div> -->
    </div>
    <alert ref="recommendCvAlert" :alertData="alertData" @close="alertData.show = false"/>
  </div>
</template>

<script>
  import api from '@/api'
	import selectCity from '@/views/editorResume/cvsEditor/components/select/selectCity'
	import selectMajor from '@/views/editorResume/cvsEditor/components/select/selectMajor'
  import selectUniversity from '@/views/editorResume/cvsEditor/components/select/selectUniversity'
  import selectUnischool from '@/views/editorResume/cvsEditor/components/select/selectUnischool'
  import selectCompany from '@/views/editorResume/cvsEditor/components/select/selectCompany'
  import selectPosition from '@/views/editorResume/cvsEditor/components/select/selectPosition'
	import degree from '@/assets/json/degree'
	import suggestCard from './suggest-card'
	import { mapState, mapMutations, mapActions } from 'vuex'
  import alert from '@/views/cvs/components/alert'

	export default {
		name: 'w-form-data',
		props: {
			formData: {
				type: Object,
				default: () => {
					return {
            present:'',
          }
				}
			},
			formList: {
				type: Array,
				default: () => []
			},
			pickerOptions: {
				type: Object,
				default: () => {
                  return {}
				}
			},
			moduleType: {
				type: [ String, Number ],
				default: ''
			},
			degreeData: {
				type: Object,
				default: () => {
					return {}
				}
			}
		},
		data () {
			const startAt = (rule, value, callback) => {
        if(!(this.formData.start_at && this.formData.end_at)){
          callback()
          return
        }
				if (new Date(this.formData.start_at).getTime() > new Date(this.formData.end_at)) {
					return callback(new Error('开始时间不能晚于结束时间'))
				}
				callback()
			}
			const endAt = (rule, value, callback) => {
        if(!(this.formData.start_at && this.formData.end_at ||new Date(this.formData.start_at).getTime() == new Date(this.formData.end_at))){
          callback()
          return
        }
				if (new Date(this.formData.start_at).getTime() > new Date(this.formData.end_at)) {
					return callback(new Error('结束时间不能早于开始时间'))
				}
				callback()
			}
			return {
				degreeValue: this.degreeData,
        defaultStartTime: '',
        defaultEndTime: '',
				// 验证规则
				rules: {
					start_at: [
						{ validator: startAt, trigger: 'blur' }
					],
					end_at: [
						{ validator: endAt, trigger: 'blur' }
					]
				},
        startTimePickerOptions: {},
        groupsEntryVisible: false, // 机构号入口 visible
        alertData: {
          show: false,
          type: 'groups'
        },
        tags: {
          en: [
            {
              label: '985',
              value: '985'
            },
            {
              label: '211',
              value: '211'
            },
            {
              label: 'Double 1st-Class',
              value: 'Double 1st-Class'
            },
            {
              label: 'QS Top100',
              value: 'QS Top100'
            }
          ],
          cn: [
            {
              label: '985',
              value: '985'
            },
            {
              label: '211',
              value: '211'
            },
            {
              label: '双一流',
              value: '双一流'
            },
            {
              label: '海外QS前100',
              value: '海外QS前100'
            }
          ]
        }
			}
		},
		mounted () {
          if (this.currentInfo.type === "edus") {
            this.defaultStartTime = new Date().getFullYear() - 4 + '-09';
          }
		},
    updated() {
      if (
        this.currentInfo.type === 'works' ||
        this.currentInfo.type === 'reasearch_experience' ||
        this.currentInfo.type === 'orgs' ||
        this.currentInfo.type === 'project_experience' ||
        (typeof this.currentInfo.type === 'number')
      ) {
        this.pickerOptions.disabledDate = (time) => {
          return time.getTime() > new Date();
        }
        this.startTimePickerOptions.disabledDate = (time) => {
          return time.getTime() > new Date();
        }
      }
    },
		computed: {
			...mapState('editor', [ 'postId', 'suggestInfo','cvDetail', 'currentInfo', 'isShowAutoWriteError' ]),
			// 学历选择的options
			degreeOption () {
				return degree
      },
      cvLang () {
        return this.cvDetail.basic_info.lang
      }
		},
    watch: {
      'currentInfo.data.title': {
        async handler () {
          if (this.currentInfo.type !== 'works') return
          if (!this.currentInfo.data.title) {
            this.setPostId('')
          } else {
            let params = {
              job_title: this.currentInfo.data.title
            }
            let res = await api.cvsEditor.getPostLevelId(params)
            if (res.code === 1000) {
              let id = res.data.level3_ids[0] || ''
              this.setPostId(id)
            }
          }
        },
        deep: true
      }
    },
		components: {
			selectCity,
			selectMajor,
      selectUniversity,
      selectUnischool,
      selectCompany,
      selectPosition,
			suggestCard,
      alert
		},
		methods: {
			...mapMutations('editor', [ 'setSuggestInfo', 'setPostId' ]),
      ...mapActions('editor', ['getPostLevelId']),

      // 学校 tag 选择之后
      schoolTagChange(val) {
        this.$emit('schoolTagChange', val)
      },

      showGroupsDialogFunc () {
        this.alertData.show = true
      },
      // 学校失去焦点
      async universityBlurFunc () {
        // console.log(this.formData.university)
        try {
          let params = {
            school_name: this.formData.university,
            type: 'editor'
          }
          let res = await api.account.getUserEntrance(params)
          if (res.code === 1000) {
            this.groupsEntryVisible = true
            this.alertData = {
              show: false,
              type: 'groups',
              groupToken: res.data.group_token,
              schoolName: res.data.school_name,
              schoolLogo: res.data.school_logo
            }
          } else {
            this.groupsEntryVisible = false
          }
          // console.log(res)
        } catch (error) {
          console.log(error)
        }
      },
      // 设置教育时间默认值
      setDefaultEduTimeVal () {
        let month = "-06";
        if(this.formData.end_at) {
          month = "-" + this.formData.end_at.split("-")[1];
        }
        if (!this.formData.start_at || !this.formData.degree) {
          this.defaultEndTime = '';
        } else {
          switch (this.formData.degree) {
            case "本科":
              this.defaultEndTime = +this.formData.start_at.split('-')[0] + 4 + month;
              break;
            case "Bachelor":
              this.defaultEndTime = +this.formData.start_at.split('-')[0] + 4 + month;
              break;
            case "MBA":
              this.defaultEndTime = +this.formData.start_at.split('-')[0] + 2 + month;
              break;
            default:
              this.defaultEndTime = +this.formData.start_at.split('-')[0] + 3 + month;
              break;
          }
        }
        this.formData.end_at = this.defaultEndTime;
      },
      // 设置时间默认值
      setDefaultTimeVal () {
        if (this.currentInfo.type === "edus") {
          this.setDefaultEduTimeVal();
        }
      },
			change (formData, type, val) {
        if (type === 'end_at') this.currentInfo.data.present = null
        console.log(this.formData, '---')
        if(type === 'start_at'){
          this.setDefaultTimeVal();
        }
        this.$forceUpdate();
        // if (!this.formData.end_at) {
        // }
			},
			// 选择城市
			selectCityValue (data) {
				this.$emit('selectCity', data)
			},
			// 选择专业
			selectMajorValue (data) {
				this.$emit('selectMajor', data)
			},
			// 选择学历
			selectDegreeValue (data) {
				let { basic_info: { lang } } = this.cvDetail
				this.formData.degree = data[lang] || null
        this.formData.degree_id = data.id || null
        // this.$emit("update-form",{key: "degree" , value: data[lang] || null})
        // this.$emit("update-form",{key: "degree_id" , value: data.id || null})

        if(!this.formData.degree){
          this.formData.edu_type = null
        }else if(lang==='cn' && !this.formData.edu_type){
          this.formData.edu_type = '全日制'
        }
        this.setDefaultTimeVal();
        this.$forceUpdate()
			},
			// 选择学校
			selectUniversityValue (data) {
        console.log(data, "================》selectUniversity")
				this.$emit('selectUniversity', data)
      },
			// 表单的校验规则
			formValidate () {
				let flag = false
				this.$refs['editModule'].validate(valid => {
					flag = valid
				})
				return flag
			},
			// 优化简历关闭
			handleClose () {
				this.setSuggestInfo({})
      },
		}
	}
</script>

<style lang="scss" scoped>
  .position-r {
    ::v-deep .el-form-item {
      .el-checkbox-group {
        display: flex;
        max-width: 100%;
        flex-wrap: wrap;
        .el-checkbox {
          margin-right: 10px;
          &.is-checked {
            .el-checkbox__label {
              color: #606266;
            }
            .el-checkbox__inner {
              background-color: #ff6644;
              border-color: #ff6644;
            }
          }
          .el-checkbox__inner {
            &:hover {
              border-color: #ff6644;
            }
          }
          .el-checkbox__label {
            //margin-left: 5px;
            padding-left: 5px;
          }
        }
      }
    }
  }
  .edit-editor-content {
    position: relative;
  }
  .edit-module-edu-main {
    padding: 0 28px;
    .edu-menu {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .edu-item {
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #9C9C9C;
        cursor: pointer;
        .edu-item-select {
          width: 16px;
          height: 16px;
          border: 1px solid #DEDFE1;
          margin-right: 12px;
          text-align: center;
          line-height: 16px;
          &.active {
            .iconfont {
              font-size: 14px;
              margin: auto;
            }
          }
        }
        .iconfont {
          margin-right: 8px;
        }
      }
    }
  }
  .inline {
    display: inline-block;
    width: 47%;
    >.suggest-card {
      top: 98px !important;
    }
  }
  .margin {
    margin-right: 6%;
  }
  .error-box{
    text-align: right;
    color: #FF6644;
    font-size: 14px;
    font-weight: 400;
    line-height: 14px;
    margin-top: 4px;
    i{
      margin-right: 6px;
    }
  }

  .groups-entry-box {
    position: absolute;
    top: 98px;
    left: 0;
    z-index: 1;
    display: flex;
    align-items: center;
    padding: 8px 12px 8px 16px;
    background: #F5F8FF;
    border-radius: 4px;
    cursor: pointer;

    .iconcv-title-icon-edus {
      font-size: 16px;
      color: #4183FF;
      margin-right: 6px;
    }

    .iconjinru {
      font-size: 12px;
      color: #4183FF;
      margin-left: 12px;
    }

    >p {
      display: flex;
      align-items: center;
      font-size: 14px;
      font-weight: 400;
      color: #4183FF;
      line-height: 20px;

      >span {
        max-width: 240px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

  }
</style>
